const actions = {
  SET_STATE: 'pages/company/aircraft/SET_STATE',
};

export default actions;
